const blocks = document.querySelectorAll('.block-content-side-testimonial');
const blocksArray = [];

const toggleContent = ({ content, button }) => {
	if (content.classList.contains('active')) {
		content.classList.remove('active');
		button.innerText = 'Show Full Details';
	} else {
		content.classList.add('active');
		button.innerText = 'Hide Full Details';
	}
};

const collapseContentInit = () => {
	if (blocks.length) {
		blocks.forEach((block, index) => {
			const button = block.querySelector(
				'.block-collapse-content__toggle'
			);
			const content = block.querySelector('.block-content');
			const { contentStartHeight, contentMaxHeight } =
				calculateContentHeights(block);

			blocksArray.push({
				blockElement: block,
				contentStartHeight,
				contentMaxHeight,
				button,
				content,
			});

			setContentHeights(blocksArray[index]);

			if (button) {
				button.addEventListener('click', (e) => {
					e.preventDefault();
					toggleContent(blocksArray[index]);
				});
			}
		});
	}
};

const setContentHeights = (blockObj) => {
	blockObj.blockElement.style.setProperty(
		'--contentStartHeight',
		`${blockObj.contentStartHeight}px`
	);
	blockObj.blockElement.style.setProperty(
		'--contentMaxHeight',
		`${blockObj.contentMaxHeight}px`
	);
};

const calculateContentHeights = (block) => {
	const heading = block.querySelector('.wp-block-heading');
	const button = block.querySelector('.block-collapse-content__toggle');
	const content = block.querySelector('.block-content');
	const testimonialBox = block.querySelector('.block-testimonial');

	const headingStyle = window.getComputedStyle(heading);
	const headingHeight =
		parseFloat(headingStyle.height) + parseFloat(headingStyle.marginBottom);

	const buttonStyle = window.getComputedStyle(button);
	const buttonHeight =
		parseFloat(buttonStyle.height) + parseFloat(buttonStyle.marginTop);

	let contentStartHeight = 0;
	let contentMaxHeight = 0;

	if (window.matchMedia('(max-width: 767px').matches) {
		contentStartHeight = 400 - buttonHeight - headingHeight;
	} else {
		contentStartHeight =
			testimonialBox.offsetHeight - buttonHeight - headingHeight;
	}

	contentMaxHeight = content.scrollHeight;

	return { contentStartHeight, contentMaxHeight };
};

const updateContentHeights = () => {
	blocksArray.forEach((blockObj) => {
		const { contentStartHeight, contentMaxHeight } =
			calculateContentHeights(blockObj.blockElement);
		blockObj.contentStartHeight = contentStartHeight;
		blockObj.contentMaxHeight = contentMaxHeight;
		setContentHeights(blockObj);
	});
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		collapseContentInit();
	},
	loaded() {
		updateContentHeights();
	},
	resized() {
		updateContentHeights();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
